<template>
	<div>
		<TriangleImage
			title="L'ortofrutta di Quomi"
			subtitle="Categoria e provenienza della nostra ortofrutta"
		/>

		<div class="container">
			<div class="content">

				<section class="center">
					<p>Qui trovi l'elenco dei prodotti ortofrutticoli in vendita su Quomi con le informazioni su categoria e provenienza.</p>
				</section>

				<h2 class='center'> Elenco dei prodotti ortofrutticoli</h2>

				<section>
					
          <table class="table">
            <tr>
              <td>Denominazione </td>
              <td>Origine</td>
              <td>Categoria</td> 
            </tr>
            <tr v-for="(product, index) in products" :key="index">
              <td>{{ product.name }}</td>
              <td>{{ product.origin_country }}</td>
              <td>{{ product.origin_category }}</td>
            </tr>
          </table>

				</section>

				<hr>

        <ContinueToShop />
			</div>

			<StartWithUs />
		</div>

	</div>
</template>

<script>

import TriangleImage from '../TriangleImage'

import StartWithUs from '../Parts/StartWithUs'
import ContinueToShop from '../Parts/ContinueToShop'
import { SupplierApi } from '../../api/SupplierApi'
import BigUsp from '../Parts/BigUsp'

export default {
	components: {
		TriangleImage,
    ContinueToShop,
		StartWithUs,
		BigUsp
	},
  data() {
    return {
      products: []
    }
  },
  mounted() {

    var sm = new SupplierApi()
    return sm.origin({}).then(i => {
      this.products = i.body.data
    })

  }
}

</script>

<style scoped>
	.content {
		max-width: 1024px;
	}

	.content > section {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		
		margin: 0px auto 30px auto;
	}

	h2 {
		margin-bottom: 30px;
	}

	h3 {
		text-align: center;
	}

	.content > section > div {
		padding: 20px 0px;
		max-width: 470px;
		margin: 0 auto;
	}

	.content > section .image {
		text-align: center;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.contacts,
	.abo {
		display: flex;
		flex-direction: column;
		align-self: start;
	}

	.calendar {
		margin: 10px 0;
	}

	.contacts-list {
		list-style: none;
	}

	.contacts-list {
		text-align: left;
		width: 250px;
	}

	.contacts-list li {
		padding: 10px 0;
	}

	.triangle-image {
		background-image: url("https://api.quomi.it/oldimg/AdobeStock_256031852-small-thumb-big.jpg");
		background-position: center center;
	}

	.fa-question-circle {
		color: var(--quomi-primary);
	}

</style>
